module.exports = __webpack_public_path__ + "img/banner-bg.14dbf751.png";